module.exports = __webpack_public_path__ + "img/EMT-BRME_GSE179572.5b154826.png";